import api from './api';

export const register = async (email, password, role) => {
  const response = await api.post('/auth/register', { 
    email, 
    password, 
    role 
  });
  return response.data;
};

export const login = async (email, password) => {
  const response = await api.post('/auth/login', { email, password });
  return response.data;
};

export const getCurrentUser = async () => {
  const response = await api.get('/auth/me');
  return response.data;
};

export const changePassword = async (oldPassword, newPassword) => {
  const response = await api.post('/auth/change-password', {
    old_password: oldPassword,
    new_password: newPassword
  });
  return response.data;
};

export const suspendUser = async (userId, reason = null) => {
  const response = await api.post(`/auth/suspend-user/${userId}`, null, {
    params: { reason }
  });
  return response.data;
};

export const unsuspendUser = async (userId) => {
  const response = await api.post(`/auth/unsuspend-user/${userId}`);
  return response.data;
};

export const logout = () => {
  localStorage.removeItem('token');
};
export const forgotPassword = async (email) => {
  const response = await api.post('/auth/forgot-password', { email });
  return response.data;
};

export const resetPassword = async (token, newPassword) => {
  const response = await api.post('/auth/reset-password', {
    token,
    new_password: newPassword
  });
  return response.data;
};
